import React from "react";
import Comingsoonpage from "../../../common/Comingsoon";

const Careers = () => {
  return (
    <div>
      <Comingsoonpage />
    </div>
  );
};

export default Careers;
